import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MultiTranslateHttpLoader } from "ngx-translate-multi-http-loader";
import { SerengetiRemoteConsoleModule } from "./app/app.module";

@Injectable({
  providedIn: 'root'
})
export class Configurations {
    public createTranslateLoader: (client: HttpClient) => MultiTranslateHttpLoader;

    public static getServiceLoginEndPoint(config: Configurations) {
      if (SerengetiRemoteConsoleModule.environment && SerengetiRemoteConsoleModule.environment.createTranslateLoader) {
        return config.getLoginEndPoint();
      } else {
        return Configurations.serviceLoginCoreEndPoint;
      }
    }

    public static getServiceConsoleEndPoint(config: Configurations) {
      if (SerengetiRemoteConsoleModule.environment && SerengetiRemoteConsoleModule.environment.createTranslateLoader) {
        return config.getConsoleEndPoint();
      } else {
        return Configurations.serviceConsoleCoreEndPoint;
      }
    }

    public static getServiceCoreEndPoint(config: Configurations) {
      if (SerengetiRemoteConsoleModule.environment && SerengetiRemoteConsoleModule.environment.createTranslateLoader) {
        return config.getEndPoint();
      } else {
        return Configurations.serviceCoreEndPoint;
      }
    }

    public static serviceLoginCoreEndPoint = 'https://serengeti.aifrica.co.kr/api.login/auth/v1/handle/';
    public static serviceConsoleCoreEndPoint = 'https://serengeti.aifrica.co.kr/api.console/console/v1/handle/';
    public static serviceCoreEndPoint = 'http://localhost:30039/';
    public static serviceDomainEndPoint = 'http://localhost:4200'

    getLoginEndPoint: () => string;
    getConsoleEndPoint: () => string;
    getEndPoint: () => string;
    getDomainEndPoint: () => string;
    getActiveState : () => boolean;
  
    constructor() {
      this.createTranslateLoader = null;
    }
    
  }